<template>
    <!-- v-if="false && driverActivities.state" -->
    <div class="plafond-container mb-3" :class="[loading && 'plafond-container--loading']">
        <div class="spinner-wrapper" v-if="loading">
            <Spinner></Spinner>
        </div>
        <template v-else-if="driverActivities.state">
            <div class="p-date">
                {{ __('plafonds.last_update') }}:
                {{ detectionDate | formatDateWithFormat('L HH:mm', 'UTC') }}
            </div>
            <div class="tiny-wrapper">
                <div class="details-wrap">
                    <h6>{{ __('plafonds.current_activity') }}</h6>
                    <PlafondDriverActivities
                        :value="driverActivities"
                        :restInfo="{
                            driveTypeNextRest,
                            driverPlafond
                        }"
                        :driver="driver"
                    />
                </div>

                <!-- Infobox per pausa di sessione -->
                <!-- <div
                    v-if="
                        driverActivities.nextState == 'REST' &&
                        driveTypeNextRest == 'SESSION' &&
                        driverPlafond?.fifteen
                    "
                    class="tiny-helper bg-info-light session-warning text-smaller"
                >
                    <p class="mb-0">
                        {{ __('plafonds.session_done') }}
                        <b>{{ driverPlafond?.fifteen?.length }} min</b>
                    </p>
                    <p class="mb-0">
                        {{ __('plafonds.session_started') }}
                        <b>{{ driverPlafond?.fifteen?.time[0] | formatDate('UTC') }}</b>
                    </p>
                    <p class="mb-0">
                        {{ __('plafonds.session_ended') }}
                        <b>{{ driverPlafond?.fifteen?.time[1] | formatDate('UTC') }}</b>
                    </p>

                    <p class="mb-0 mt-2">
                        <b>{{ __('plafonds.session_choice') }}</b>
                    </p>
                </div> -->

                <div class="details-wrap">
                    <h6>{{ __('plafonds.mini_plafond') }}</h6>
                    <div class="d-flex table-element">
                        <div style="min-width: 20px">
                            <i class="fa-solid fa-user-clock"></i>
                        </div>
                        <div style="min-width: 98px; flex-grow: 1">
                            {{ __('residual_commitment') }}<span v-if="driveBonus">*</span>
                        </div>
                        <div class="">{{ residualWorkingDay }}</div>
                    </div>
                    <div class="d-flex table-element">
                        <div style="min-width: 20px">
                            <i class="fa-solid fa-steering-wheel"></i>
                        </div>
                        <div style="min-width: 98px; flex-grow: 1">
                            {{ __('residual_driving') }}<span v-if="restBonus">*</span>
                        </div>
                        <div class="">{{ residualDriveDay }}</div>
                    </div>
                    <div class="d-flex table-element">
                        <div style="min-width: 20px"><i class="fa-solid fa-ticket"></i></div>
                        <div style="min-width: 98px; flex-grow: 1">
                            {{ __('residual_bonuses') }}
                        </div>
                        <div class="d-flex flex-column align-items-end">
                            <div>{{ __('driving') }}: {{ driveBonus }}</div>
                            <div>{{ __('rest') }}: {{ restBonus }}</div>
                        </div>
                    </div>
                </div>
                <div v-if="showTinyHelper" class="tiny-helper">* {{ __('consider_bonuses') }}</div>
                <div class="d-flex justify-content-center mt-2">
                    <!-- TODO: Check permesso visualizzazione plafond, se c'è. -->
                    <!-- v-if="$can('use', 'planner')" -->
                    <golia-button
                        @click="openPlafond"
                        variant="btn-fill dark-blue mt-3"
                        :label="__('view_plafond_detail')"
                    />
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { ref, toRefs } from 'vue'
import Spinner from 'vue-simple-spinner'
import useDriverPlafond from '../composables/useDriverPlafond'
import driverPrimaryId from '../functions/driverPrimaryId'

export default {
    name: 'TinyPlafond',
    components: {
        Spinner,
        PlafondDriverActivities: () => import('./PlafondDriverActivities')
    },
    props: {
        driver: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const { driver } = toRefs(props)

        const {
            driverActivities,
            detectionDate,
            driveBonus,
            residualWorkingDay,
            restBonus,
            residualDriveDay,
            driverPlafond,
            loading,
            getPlafond,
            cleanDriver,
            driveTypeNextRest
        } = useDriverPlafond(driver)

        return {
            detectionDate,
            driverActivities,
            residualWorkingDay,
            restBonus,
            residualDriveDay,
            driveBonus,
            driverPlafond,
            loading,
            getPlafond,
            cleanDriver,
            driveTypeNextRest
        }
    },
    data() {
        return {
            date: null
        }
    },
    watch: {
        driver: {
            immediate: true,
            handler() {
                this.getPlafond({ vueInstance: this })
            }
        }
    },
    computed: {
        showTinyHelper() {
            return this.driveBonus || this.restBonus
        }
    },
    methods: {
        openPlafond() {
            this.$router.push({
                name: 'geofleet.driver_plafond',
                params: {
                    id: this.$route.params.id,
                    driver_id: driverPrimaryId(this.driver)
                }
            })
        }
    }
}
</script>

<style scoped>
.spinner-wrapper {
    height: 45px;
    background-color: rgb(255 255 255 / 9%);
}
.plafond-container {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    font-size: 0.7rem;
    border-radius: 15px;
}
.plafond-container--loading {
    min-height: 30px;
}
.tiny-wrapper {
    display: flex;
    flex-direction: column;
}
.p-date {
    /* font-size: 0.7rem;
    font-weight: 400; */
    padding-bottom: 8px;

    color: #849ba5;
    font-size: 0.7rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-transform: uppercase;
}

.rest {
    color: #87cb7e;
}
.available {
    color: #96cee9;
}
.work {
    color: #fc9e42;
}
.drive {
    color: #e83744;
}
.details-wrap {
    padding: 8px 5px 5px 5px;
}
.details-wrap i {
    font-size: 0.8rem;
}
.details-wrap h6 {
    color: #2d2d2d;
    font-size: 0.7rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
}
.table-element {
    gap: 5px;
    border-bottom: 1px solid var(--main-gray);
    margin-bottom: 2px;
    padding-bottom: 2px;
}
/* .tiny-txt {
    padding-bottom: 2px;
} */
.tiny-helper {
    font-size: 0.65rem;
    padding-left: 5px;
    padding-top: 5px;
}
.session-warning {
    padding: 10px;
    border-radius: 8px;
    margin: 5px;
    margin-bottom: 10px;
}
</style>
